// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--3L5Rb";
export var description = "footer-module--description--i8Hvi";
export var copyright = "footer-module--copyright--3WaIr";